import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { withCookies } from 'react-cookie';

import Login from '../pages/Login';
import { Contacts } from '../pages/Contacts';
import Review from '../pages/Review';
import AddContact from '../pages/AddContact';
import CustomerSupport from '../pages/CustomerSupport';
import ScrollToTop from './ScrollToTop';
import LoggedInLayout from '../layout/LoggedInLayout';
import { useUserContext } from '../contexts/UserContext';
import EngagementPage from '../pages/EngagementPage';
import LoggedOutLayout from '../layout/LoggedOutLayout';
import ImportCsv from '../pages/ImportCsv';


function MainRouter() {
  const userContext = useUserContext();

  const isLoggedIn = userContext.isLoggedIn();
  return (
    <ScrollToTop>
      {userContext.cookiesLoaded && <Routes>
        <Route element={<LoggedOutLayout/>}>
          <Route path="/contactRequest" element={<EngagementPage/>}/>
        </Route>

        {!isLoggedIn ?
          <>
            <Route path="/*" element={<Login/>}/>
          </> :
          <>
            <Route element={<LoggedInLayout/>}>
              <Route path="/contacts" element={<Contacts/>}/>
              {/*<Route path="/birthday" element={<Birthday/>}/>*/}
              <Route path="/review" element={<Review/>}/>
              <Route path="/add" element={<AddContact/>}/>
              <Route path="/import" element={<ImportCsv/>}/>
              <Route path="/support" element={<CustomerSupport/>}/>
              <Route path="*" element={<Navigate to="/contacts" replace/>}/>
            </Route>
          </>
        }

      </Routes>}
    </ScrollToTop>
  );
}

export default withCookies(MainRouter);
